import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 7%;
`;

export const Content = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const TextWrapper = styled(Typography)`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
`;

export const AmountWrapper = styled(Typography)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: end;
`;

export const ContentText = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const TransactionTime = styled(Typography)`
  color: #000;
  font-family: "NotoSans-SemiBold";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const ActionsWrapper = styled(Box)`
  display: flex;
  width: 100%;
`;

export const PriceTransaction = styled(Box)`
  display: flex;
`;
